// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xFFI","name":"styles_name__6zC5_","phone":"styles_phone__11CdP"};